import { render } from "./AssessmentUnfulfilledPurchasesPage.vue?vue&type=template&id=1fae08c2"
import script from "./AssessmentUnfulfilledPurchasesPage.vue?vue&type=script&lang=js"
export * from "./AssessmentUnfulfilledPurchasesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__